import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trends-page',
  templateUrl: './trends-page.component.html',
  styleUrls: ['./trends-page.component.scss']
})
export class TrendsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
